export default __webpack_public_path__ + "static/media/tkit-2-md.a22b4069.svg";